import React from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck, Camera, Clock } from "lucide-react";

const BG = "https://images.unsplash.com/photo-1771360963016-1408c2de12c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwa2l0Y2hlbiUyMGNoZWYlMjBjb29raW5nJTIwY2xlYW4lMjBtb2Rlcm58ZW58MHx8fHwxNzg3NjkxNDMwfDA&ixlib=rb-4.1.0&q=85";

export default function Welcome() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      {/* Left / hero */}
      <div className="relative md:w-1/2 md:min-h-screen flex flex-col justify-end px-6 pt-[calc(1.5rem+env(safe-area-inset-top))] pb-7 md:p-12 overflow-hidden" data-testid="welcome-hero" data-surface="dark">
        <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-brand-surface/[0.82]" />
        <div className="relative z-10">
          <div className="flex justify-center mb-4 md:mb-8"><div className="inline-flex items-center justify-center rounded-xl bg-white px-3 py-2 shadow-lg" data-testid="welcome-logo-panel"><Logo size="sm" className="h-11 md:h-12" /></div></div>
          <h1 className="font-display text-[1.75rem] sm:text-4xl md:text-5xl font-semibold text-white leading-tight max-w-md" data-testid="welcome-tagline">
            Less time spent on admin, <span className="text-brand">more time to do what you do best</span>
          </h1>
          <p className="hidden sm:block text-white/85 mt-4 max-w-sm">One digital companion for temperatures, cleaning, prep, checklists and ordering — with accountability built into every entry.</p>
        </div>
      </div>

      {/* Right / CTA */}
      <div className="md:w-1/2 flex items-center justify-center px-6 py-5 md:p-12">
        <div className="w-full max-w-sm">
          <div className="inline-flex items-center gap-2 bg-brand-light text-brand-dark text-xs font-semibold px-3 py-1.5 rounded-full mb-3 md:mb-6">
            <span className="h-2 w-2 rounded-full bg-brand animate-pulse" /> Digital Kitchen Management
          </div>
          <h2 className="font-display text-3xl font-semibold text-slate-900">Welcome!</h2>
          <p className="text-slate-500 mt-0.5 text-base md:text-lg">Let's get cookin'</p>

          <div className="space-y-2 md:space-y-3 my-4 md:my-8">
            {[[ShieldCheck, "Every action signed & timestamped"], [Camera, "Photo evidence when it matters"], [Clock, "Save hours of admin each week"]].map(([Icon, t], i) => (
              <div key={i} className="flex items-center gap-3 text-sm text-slate-600">
                <div className="h-9 w-9 rounded-lg bg-brand-light flex items-center justify-center"><Icon size={18} className="text-brand-dark" /></div>
                {t}
              </div>
            ))}
          </div>

          <Button onClick={() => navigate("/login")} data-testid="start-button"
            className="w-full h-12 md:h-14 text-base font-bold bg-brand hover:bg-brand-hover rounded-2xl shadow-lg shadow-brand/20">
            Sign in <ArrowRight className="ml-1.5" size={20} />
          </Button>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-3">
            <Button variant="outline" onClick={() => navigate("/signup")} data-testid="journey-personal" className="h-auto min-h-12 py-2 whitespace-normal leading-tight rounded-2xl">Create my CaterCTRL profile</Button>
            <Button variant="outline" onClick={() => navigate("/login")} data-testid="journey-business" className="h-auto min-h-12 py-2 whitespace-normal leading-tight rounded-2xl">Set up CaterCTRL for my business</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
